import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Globe, Check } from 'lucide-react'
import { languages } from '../../i18n'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const currentLanguage = i18n.language?.substring(0, 2) || 'de'
  const currentLang = languages[currentLanguage as keyof typeof languages] || languages.de

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        data-testid="language-switcher-open-btn"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <Globe size={18} />
        <span className="hidden sm:inline">{currentLang.flag} {currentLanguage.toUpperCase()}</span>
        <span className="sm:hidden">{currentLang.flag}</span>
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
            {Object.entries(languages).map(([code, lang]) => (
              <button
                data-testid="language-switcher-btn"
                key={code}
                onClick={() => changeLanguage(code)}
                className={`flex items-center justify-between w-full px-4 py-2 text-sm transition-colors ${
                  currentLanguage === code
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span className="flex items-center gap-2">
                  <span>{lang.flag}</span>
                  <span>{lang.name}</span>
                </span>
                {currentLanguage === code && (
                  <Check size={16} className="text-primary-600" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
